// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_rh","imageUI":"e_sh","badgeContainer":"e_th","badgeImage":"e_uh","container":"e_vh"};